import { InjectionToken } from '@angular/core';

export const API_SERVER_TOKEN = new InjectionToken<string>('ApiServer');
